import _ from "lodash";
import { CONSTANTS } from "config";
import { UTILS } from "utils";

export const handleAxiosErrorResponse = (error) => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx

    if (isValidObject(["response", "data", "message"], error)) {
      if (
        isValidObject(["response", "data", "errors"], error) &&
        error.response.data.errors.length > 0
      ) {
        return {
          err: {
            msg: error.response.data.errors[0],
            statusCode: error.response.status,
          },
        };
      }

      return {
        err: {
          msg: error.response.data.message,
          statusCode: error.response.status,
        },
      };
    } else {
      return {
        err: {
          msg: "Request Failed",
          statusCode: error.response ? error.response.status : "",
        },
      };
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    return { err: { msg: "Request Failed" } };
  } else {
    // Something happened in setting up the request that triggered an Error
    return { err: { msg: "Request Failed" } };
  }
};

export const isValidObject = (attributesArray, object) => {
  if (attributesArray === null) {
    if (object === null || typeof object === "undefined") return false;
    return true;
  } else if (object === null || typeof object === "undefined") return false;

  // NULL will not be considered as valid object
  const res = attributesArray.reduce((xs, x) => {
    return isValidObjectHelper(xs) && isValidObjectHelper(xs[x]) ? xs[x] : null;
  }, object);

  if (res === null) return false;
  return true;
};

function isValidObjectHelper(obj) {
  if (obj !== null && typeof obj !== "undefined") return true;
  return false;
}

export const isString = function (obj) {
  let res = _.isString(obj);
  if (res === true && obj.trim().length > 0) return true;
  return false;
};

export const isNumber = function (obj) {
  if (_.isFinite(obj)) return true;

  return false;
};

export const isEmailValid = function (email) {
  /* eslint-disable */
  const emailValidationRegex = RegExp(
    /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z]{2,}))$/
  );
  /* eslint-enable */
  return emailValidationRegex.test(email);
};

export const toNumber = (obj) => _.toNumber(obj);

export const isAuthorizedUser = function (obj) {
  if (
    isValidObject(["statusCode"], obj) &&
    obj.statusCode === CONSTANTS.STATUS_CODE_401
  )
    return false;
  return true;
};
export const validateVideoFile = (file, setError = () => {}) => {

  const isVideoFile = file?.type?.includes("video");
  if (!isVideoFile) {
    const message = "You can only upload video files.";
    UTILS.errorNotification(message);
    setError(message);
    return false;
  }

  const videoMimeTypes = [
    "video/mp4",
    "video/webm",
    "video/ogg",
    "video/x-msvideo", // AVI
    "video/quicktime", // MOV
    "video/x-ms-wmv", // WMV
    "video/x-flv", // FLV
    "video/x-matroska", // MKV
  ];
  if (!videoMimeTypes?.includes(file?.type)) {
    const message = `Invalid video file type: ${
      file?.type
    }, Only ${videoMimeTypes.join(", ")} are allowed`;
    UTILS.errorNotification(message);
    setError(message);
    return false;
  }

  const validSizeInMB = 1024 * CONSTANTS.MAX_VIDEO_SIZE;
  const fileSizeMB = file?.size / 1024;
  if (fileSizeMB > validSizeInMB) {
    const message = `The video must be less than ${CONSTANTS.MAX_VIDEO_SIZE}MB in size.`;
    UTILS.errorNotification(message);
    setError(message);
    return false;
  }
  return true;

};

export const validateMerchantSavingField = (field, value, defaultErrors={}) => {
  const fieldErrors = {...defaultErrors};

  switch (field) {
    case "vendorName":
      if (!value || value.trim().length === 0) {
        fieldErrors.vendorName = "Vendor name is required";
      } else if (value.trim().length < 3) {
        fieldErrors.vendorName = "Vendor name must be at least 3 characters and not empty";
      }
      break;

    case "vendorBenchmark": {
      const num = Number(value);
      const isEmpty =
        value === "" ||
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "");
      if (isEmpty) {
        fieldErrors.vendorBenchmark = "Vendor benchmark is required";
      } else if (isNaN(num) || num < 0) {
        fieldErrors.vendorBenchmark = "Benchmark must be a non-negative number";
      }
      break;
    }

    default:
      break;
  }

  return fieldErrors;
};